export const PUBLIC_FORM_PATH = '/forms/:token';
export const PUBLIC_FORM_REQUEST_PATH = '/forms/request/:token';
